import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SaveOpeningBalanceModel } from '@app/core/Models';
import { environment } from '@environments/environment';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';
import { CommonService } from '..';
@Injectable({
  providedIn: 'root',
})
export class AccountProductionService {
  constructor(private http: HttpClient, private commonService: CommonService) {}

  refreshAccountProductionTrialBalance(
    accountingPeriodId: Guid
  ): Observable<any> {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.post<any>(
      `${environment.apiVersionUrl}AccountProduction/refreshTrialBalance/${accountingPeriodId}`,
      headers
    );
  }

  getAccountProductionTrialBalance(
    accoutingPeriodId: Guid
  ): Observable<Array<any>> {
    return this.http.get<Array<any>>(
      `${environment.apiVersionUrl}AccountProduction/getBasedOnAccountingPeriod/${accoutingPeriodId}`
    );
  }

  saveTrialBalance(trialBalance: SaveOpeningBalanceModel): Observable<any> {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.post<any>(
      `${environment.apiVersionUrl}AccountProduction/saveTrialBalance`,
      this.commonService.trimObjectSpace(JSON.stringify(trialBalance)),
      headers
    );
  }

  getAccountProductionTrialBalanceByJurnal(
    jurnalId: Guid
  ): Observable<Array<any>> {
    return this.http.get<Array<any>>(
      `${environment.apiVersionUrl}AccountProduction/getAllTrialBalanceBasedOnJournalId/${jurnalId}`
    );
  }

  getAllJournalsBasedOnAccountingPeriodId(
    jurnalId: Guid
  ): Observable<Array<any>> {
    return this.http.get<Array<any>>(
      `${environment.apiVersionUrl}AccountProduction/getAllJournalsBasedOnAccountingPeriodId/${jurnalId}`
    );
  }

  deleteTBJurnal(
    jurnalId: Guid
  ): Observable<Array<any>> {
   
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(jurnalId),
    };
    return this.http.delete<any>(
      `${environment.apiVersionUrl}AccountProduction/deletejournal`,
      options
    );
  }

  getAutoRoundingSettingAccounts(): Observable<any> {
    return this.http.get<any>(
      `${environment.apiVersionUrl}AccountProduction/autoRoundingSetting/accounts`
    );
  }

  saveAutoRoundingSetting(payload: any): Observable<any> {
    const headers = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    return this.http.post<any>(
      `${environment.apiVersionUrl}AccountProduction/autoRoundingSetting`,
      JSON.stringify(payload),
      headers
    );
  }

  getAutoRoundingSettingList(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiVersionUrl}AccountProduction/autoRoundingSetting`
    );
  }

  getAutoRoundingCompanySetting(): Observable<any> {
    return this.http.get<any>(
      `${environment.apiVersionUrl}AccountProduction/autoRoundingSetting/company`
    );
  }

  updateAutoRoundingCompanySetting(isAutoRounding: boolean): Observable<any> {
    return this.http.put<any>(
      `${environment.apiVersionUrl}AccountProduction/autoRoundingSetting/company/${isAutoRounding}`,
      null
    );
  }

  getAutoRoundingSettingById(id: string): Observable<any> {
    return this.http.get<any>(
      `${environment.apiVersionUrl}AccountProduction/autoRoundingSetting/${id}`
    );
  }

  updateAutoRoundingSetting(id: string, payload: any): Observable<any> {
    const headers = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    return this.http.put<any>(
      `${environment.apiVersionUrl}AccountProduction/autoRoundingSetting/${id}`,
      JSON.stringify(payload),
      headers
    );
  }

  deleteAutoRoundingSetting(id: string): Observable<any> {
    return this.http.delete<any>(
      `${environment.apiVersionUrl}AccountProduction/autoRoundingSetting/${id}`
    );
  }
}

